/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-unresolved */
import { TourProvider } from "@reactour/tour";
import { Button as MuiBtn } from "@material-ui/core";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import { noop } from "src/globalConsts";
import { acceptGuide } from "./utils";

export enum WizardModes {
  ADMIN = "admin",
  USER = "user",
  MOBILE = "mobile",
}

type Props = {
  children: ReactNode;
};

type SetWizardMode = (wizardMode: WizardModes) => void;

const WizardModeContext = createContext<SetWizardMode>(noop);

const ReactTourProvider = ({ children }: Props) => {
  const [wizardMode, setWizardMode] = useState(WizardModes.USER);
  const [currStep, setCurrStep] = useState(0);

  const disableBody = (target: Element | null): void => {
    if (target) {
      disableBodyScroll(target);
    }
  };

  const enableBody = (target: Element | null): void => {
    if (target) {
      enableBodyScroll(target);
    }
  };

  const setWizardCallback = useCallback(
    (wizard: WizardModes) => setWizardMode(wizard),
    []
  );

  const nextButton = ({
    currentStep,

    stepsLength,
    Button,
    setIsOpen,
  }: any) => {
    const isLastStep = currentStep === stepsLength - 1;

    const handleOnClick = () => {
      if (isLastStep) {
        setIsOpen(false);
      } else {
        setCurrStep((prevStep) => prevStep + 1);
      }
    };

    if (isLastStep)
      return (
        <MuiBtn
          disableFocusRipple
          onClick={() => {
            acceptGuide(wizardMode);
            setIsOpen(false);
          }}
          color="primary"
          variant="text"
        >
          Ukončit
        </MuiBtn>
      );

    return <Button onClick={handleOnClick} />;
  };

  return (
    <TourProvider
      steps={[]}
      afterOpen={disableBody}
      beforeClose={enableBody}
      setCurrentStep={setCurrStep}
      currentStep={currStep}
      showNavigation={currStep > 0}
      onClickClose={(clickProps) => {
        acceptGuide(wizardMode);
        clickProps.setIsOpen(false);
      }}
      nextButton={nextButton}
      showPrevNextButtons={currStep > 0}
      disableInteraction
      showCloseButton
    >
      <WizardModeContext.Provider value={setWizardCallback}>
        {children}
      </WizardModeContext.Provider>
    </TourProvider>
  );
};

export const useSetWizardContext = () => {
  const setWizard = useContext(WizardModeContext);

  if (!setWizard) {
    throw Error(
      "Invalid Set Wizard Context, check if the consumer is inside context provider"
    );
  }

  return setWizard;
};

export default ReactTourProvider;
